import styled from 'styled-components';
import {Space} from 'antd';
import {typographyStyles} from '../../../../../utils/styles';

const StyledApprovalsTab = styled.div`
  padding: 16px 0 32px 0;
  width: 100%;

  .ant-checkbox-disabled+span {
    color: inherit;
  }
`;

const StyledApprovalsTabSpace = styled(Space)`
  width: 100%;

  & > .ant-space-item {
    align-items: center;
    display: flex;
    justify-content: center;
    width: 100%;
  }
`;

const StyledApprovalsTabReviewsCount = styled.span`
  ${typographyStyles.footnote.description};
  background-color: ${props => props.theme.colors.neutral_3};
  border-radius: 16px;
  color: ${props => props.theme.colors.neutral_8};
  display: inline-block;
  padding: 2px 8px;
`;

const StyledApprovalsTabActionsSpace = styled(Space)`
  width: 100%;

  & > .ant-space-item {
    align-items: center;
    display: flex;
    width: 100%;
  }

  .approvals-tab-review-buttons {
    padding: 0;
  }
`;


export {
  StyledApprovalsTab,
  StyledApprovalsTabSpace,
  StyledApprovalsTabReviewsCount,
  StyledApprovalsTabActionsSpace,
}
